import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy, AuthActionCodes, JobConsole_Search_Mode, Priorities } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
import { ComplainService } from '../../Services/ComplainService';
import { GenericMaster, GenericMaster_String, LocationLookup, CallDescriptionLookup, CallCategoryLookup, VIP } from '../../Models/GlobalEntities';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
    selector: 'JobSearchResult',
    templateUrl: './JobSearchResult.html'
})

export class JobSearchResult extends BaseComponent implements OnInit, OnDestroy {
    _RequestModel: ComplainSearch;
    Model: ListResponse;
    DateFormat: string;
    Timer: any;
    isCrisisCalled: boolean = false;
    cDate: Date = new Date();
    SortParams: Array<GenericMaster_String> = [];
    SortByText: string = "";
    boldUserId: number;
    _ComplainSearch_GroupBy = ComplainSearch_GroupBy;
    _CallStatus = CallStatuses;
    @Input() HideTotalPages: boolean = false;
    @Input() Mode: JobConsole_Search_Mode = JobConsole_Search_Mode.Default;
    Search_Mode = JobConsole_Search_Mode;
    @Output() onResultRefresh: EventEmitter<number> = new EventEmitter<number>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
        this.CreateSortParams();
        this.boldUserId = this.masterService.LoggedInUserData.StaffId;
    }

    CreateSortParams(): void {
        this.SortParams = [
              { Id: "Attachment", Name: "BTN.BTN_ATTACHMENTS" }
            , { Id: "IsEsc desc", Name: "BTN.BTN_ESCALATED" }
            , { Id: "DisplayCallNo asc", Name: "BTN.BTN_CALLNO_ASC" }
            , { Id: "DisplayCallNo desc", Name: "BTN.BTN_CALLNO_DESC" }
            , { Id: "ReportedAt", Name: "BTN.BTN_DATE_ADDED" }       
            , { Id: "Priority", Name: "BTN.BTN_PRIORITY" }         
            , { Id: "Remarks", Name: "BTN.BTN_REMARKS" }
            , { Id: "LastUpdate", Name: "BTN.BTN_UPDATED_DATE_TIME" }
        ]
    }

    ngOnDestroy(): void {
        window.clearInterval(this.Timer);
        //this.complainService.JobConsoleRefreshEvent.;
    }


    ngOnInit(): void {

        this.isCrisisCalled = false;

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        // this.RequestModel.Properties.push(this.masterService.LoggedInUserData.PropertyId);

        let m: any;
        m = momentDuration;
        m(moment);

        this.Timer = setInterval(() => this.onTimeLeftTimer(), 1000);
        
        this.complainService.JobConsoleRefreshEvent.pipe(untilDestroyed(this)).subscribe((ComplainId) => {
            this.onJobConsoleToUpdate(ComplainId);
        });

        this.complainService.ComplainRowChanged.pipe(untilDestroyed(this)).subscribe((data) => {
            this.onComplainRowChanged(data);
        });

        this.complainService.ComplainRowAdded.pipe(untilDestroyed(this)).subscribe((data) => {
            this.onComplainRowAdded(data);
        });
    }

    @Input("RequestModel") set RequestModel(Model: ComplainSearch) {
        this._RequestModel = Model;
    }

    get RequestModel(): ComplainSearch {
        return this._RequestModel;
    }

    @Input() Show(): void {
        this.SetData();
    }

    onTimeLeftTimer(): void {
        this.cDate = new Date();

        if (this.Model == null)
            return;

        if (this.Model.Result == null)
            return;

        for (let i = 0; i < this.Model.Result.length; i++) {
            let row = this.Model.Result[i];

            row.TimeLeftText = "00:00";
            
            if (row.IsEsc == false && row.NextEscTime != null && row.NextEscTime >= new Date()) {
                let dtEnd = moment(row.NextEscTime);
                let dtNow = moment();
                let dura = moment.duration(dtEnd.diff(dtNow));
                //console.info(row.JobEndTime);

                row.TimeLeftText = dura.format('dd:hh:mm:ss', { trim: 'all' });
            }

            if (row.IsEsc == true && row.FirstEscalationTime != null) {
                let dtEsc = moment(row.FirstEscalationTime);
                let dtNow = moment();
                let dura = moment.duration(dtNow.diff(dtEsc));
                //console.info(row.JobEndTime);

                row.TimeLeftText = dura.format('dd:hh:mm:ss', { trim: 'all' });
            }
        }
    }

    SetData(): void {

        if (this.RequestModel == null)
            return;

        /*if (this.RequestModel.Priority != 4) {
            this.isCrisisCalled = false;
        }

        if (this.isCrisisCalled)
            return;

        if (this.RequestModel.Priority == 4) {
            this.isCrisisCalled = true;
        }*/

        this.complainService.SelectedJob = null; 

        this.IsSubmitting = true;

        this.complainService.Complain_Search(this.RequestModel).then(data => {
            this.Model = data;
            this.RequestModel.PageNumber = data.CurrentPage;
            this.onTimeLeftTimer();
            this.IsSubmitting = false;

            this.onResultRefresh.emit(1);

        }).catch(reason => {
            this.IsSubmitting = false;
        })
    }

    onRowSelected(row: any): void {
        if (row == null) {
            this.complainService.SelectedJob = null;
            return;
        }

        if (this.complainService.SelectedJob != null && this.complainService.SelectedJob.ComplainId == row.ComplainId)
            this.complainService.SelectedJob = null;
        else
            this.complainService.SelectedJob = row;
    }

    onPageChange(): void {
        this.SetData();
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SortByText = row.Name;
        this.SetData();
    }

    onJobConsoleToUpdate(ComplainId: number): void {
        //this.SetData();
    }

    isFilterMatch(data: any): boolean {
        let m = true;

        if (data.DeptId == null) {
            return false;
        }

        if (this.RequestModel.Properties != null && this.RequestModel.Properties.length > 0) {
            if (this.RequestModel.Properties.findIndex(a => a == data.PropertyId) < 0)
                return false;
        }

        if (this.CheckAuth_Dept_Action(data.PropertyId, data.DeptId, AuthActionCodes.CallConsoleView) == false)
            return false;

        if (this.Mode == JobConsole_Search_Mode.Crisis && data.Priority != Priorities.Crisis)
            return false;

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.AssignedTo != null && this.RequestModel.AssignedTo.length > 0) {
            if (this.RequestModel.AssignedTo.findIndex(a => a == data.AssignedTo) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.Departments != null && this.RequestModel.Departments.length > 0) {
            if (this.RequestModel.Departments.findIndex(a => a == data.DeptId) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.CallCategories != null && this.RequestModel.CallCategories.length > 0) {
            if (this.RequestModel.CallCategories.findIndex(a => a == data.CategoryId) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.CallDescriptions != null && this.RequestModel.CallDescriptions.length > 0) {
            if (this.RequestModel.CallDescriptions.findIndex(a => a == data.CallDescriptionsId) < 0)
                return false;
        }

        

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.Locations != null && this.RequestModel.Locations.length > 0) {
            if (this.RequestModel.Locations.findIndex(a => a == data.LocationId) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.LoggedBy != null && this.RequestModel.LoggedBy.length > 0) {
            if (this.RequestModel.LoggedBy.findIndex(a => a == data.LoggedBy) < 0)
                return false;
        }

        

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.RequestedBy != null && this.RequestModel.RequestedBy.length > 0) {
            if (this.RequestModel.RequestedBy.findIndex(a => a == data.RequestedByStaffId) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.Sections != null && this.RequestModel.Sections.length > 0) {
            if (this.RequestModel.Sections.findIndex(a => a == data.SectionId) < 0)
                return false;
        }

        if (this.Mode != JobConsole_Search_Mode.Crisis && this.RequestModel.VIPCodes != null && this.RequestModel.VIPCodes.length > 0) {
            if (this.RequestModel.VIPCodes.findIndex(a => a == data.Vip) < 0)
                return false;
        }

        //if (this.Mode == JobConsole_Search_Mode.Crisis && this.RequestModel.Priority != null && this.RequestModel.Priority == )

        return m;
    }

    onComplainRowAdded(data: any): void {
        if (this.isFilterMatch(data) == false) {
            return;
        }

        if (this.Model == null || this.Model.Result == null) {
            this.Model = new ListResponse();
            this.Model.CurrentPage = 1;
            this.Model.TotalRecords = 1;
            this.Model.Result = [data];
            this.Model.HasError = false;
        }
        else {
            this.Model.TotalRecords = this.Model.TotalRecords + 1
            this.Model.Result.unshift(data);
        }
    }

    onComplainRowChanged(data: any): void {
        if (this.Model == null || this.Model.Result == null)
            return;

        if (this.Mode == JobConsole_Search_Mode.Crisis && data.Priority == Priorities.Crisis && data.CurrentStatus == CallStatuses.Close) {
            let idxDel = this.Model.Result.findIndex(a => a.ComplainId == data.ComplainId);
            if (idxDel >= 0) {
                this.Model.Result.splice(idxDel, 1);
                this.Model.TotalRecords = this.Model.Result.length;
            }
            return;
        }

        for (let i = 0; i< this.Model.Result.length; i++) {
            let row = this.Model.Result[i];
            if (row.ComplainId == data.ComplainId) {
                row = _.assign(row, data);
                return;
            }
        }
        if (this.Mode == JobConsole_Search_Mode.Crisis && data.Priority == Priorities.Crisis && data.CurrentStatus != CallStatuses.Close) {
            if (this.Model.Result && this.Model.Result.length == 0) {
                this.Model.Result.push(data);
                this.Model.TotalRecords = 1;
            }
            else {
                let idxAdd = this.Model.Result.findIndex(a => a.ComplainId == data.ComplainId);
                if (idxAdd < 0) {
                    this.Model.Result.unshift(data);
                    this.Model.TotalRecords = this.Model.Result.length;
                }
            }
        }

        
        
    }

    TrackResult(index, row): any {
        return row.ComplainId;
    }
    
    getBoldedText(row: any): string {
        if(row.AssignedTo == this.boldUserId) {
            return `<strong>${row.AssignToName}</strong>`
        } else {
            return row.AssignToName
        }
    }
}
